module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Giebenach-f60c7fce014e4a9e2c5f8bc9fea4e09a.svg";